/**
 * Mimu cart bridge (launch page only).
 *
 * Horizon builds the cart drawer's item list from section HTML returned with the
 * add-to-cart request, and its own form asks for it via `sections=`. The Appstle
 * bundle widget adds items with its own request and never asks for that HTML, nor
 * fires the theme's `cart:update` event — so the bubble count moves while the
 * drawer body stays empty until a page refresh.
 *
 * This bridge watches for an Appstle add, then dispatches the theme's OWN
 * `cart:update` event with the real cart. From there the theme does the work:
 *   - component-cart-items.js  -> no `sections` in the payload, so it falls back to
 *                                 sectionRenderer.renderSection() and rebuilds itself
 *   - cart-icon.js             -> reads data.itemCount for the bubble
 *   - cart-drawer.js           -> #handleCartAdd opens the drawer (it has auto-open)
 *
 * Deliberately no patching of window.fetch or XMLHttpRequest: the add is detected by
 * clicking, then confirmed by polling /cart.js, so nothing of ours sits in the path
 * of the theme's or the app's own cart requests.
 */
(function () {
  var ADD_BUTTON = '.ab-mix-and-match-add-to-cart-button';
  var POLL_MS = 400;
  var MAX_WAIT_MS = 9000;

  var watching = false;

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(
      function (r) {
        if (!r.ok) throw new Error('cart.js ' + r.status);
        return r.json();
      }
    );
  }

  function announce(cart) {
    // Same event name and payload shape the theme's own CartAddEvent uses.
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: 'mimu-appstle-bridge',
          data: {
            source: 'mimu-appstle-bridge',
            itemCount: cart.item_count
          }
        }
      })
    );
  }

  function openDrawerIfNeeded() {
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer) return;
    // When the drawer has auto-open the theme opens it itself on cart:update;
    // only step in when it doesn't, so it can never open twice.
    if (drawer.hasAttribute('auto-open')) return;
    if (typeof drawer.showDialog === 'function') drawer.showDialog();
  }

  function watchForAdd() {
    if (watching) return;
    watching = true;

    getCart()
      .then(function (before) {
        var startedAt = Date.now();

        (function poll() {
          if (Date.now() - startedAt > MAX_WAIT_MS) {
            watching = false;
            return;
          }
          setTimeout(function () {
            getCart()
              .then(function (current) {
                if (current.item_count !== before.item_count) {
                  watching = false;
                  announce(current);
                  openDrawerIfNeeded();
                } else {
                  poll();
                }
              })
              .catch(function () {
                watching = false;
              });
          }, POLL_MS);
        })();
      })
      .catch(function () {
        watching = false;
      });
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (target && target.closest && target.closest(ADD_BUTTON)) watchForAdd();
    },
    true
  );
})();
